import {
  IonApp,
  IonRouterOutlet,
  IonSplitPane,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import Menu from "./components/Menu";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import Alerts from "./pages/Alerts";
import Tracking from "./pages/Tracking";
import Graphs from "./pages/Graphs";
import DeviceDetails from "./pages/DeviceDetails";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import { useEffect, useState } from "react";

import { useAuth } from "./pages/auth/AuthContext";
import UserMgmt from "./pages/UserMgmt";
import Datasheets from "./pages/Datasheets";
import { useDispatch } from "react-redux";
import { setUserMetadata } from "./redux/actions";

setupIonicReact();

const App: React.FC = () => {
  const { authInfo, initialize } = useAuth()!;
  const dispatch = useDispatch();

  useEffect(() => {
    !authInfo?.initialized && (async () => await initialize())();
    // console.log("authInfo: " + JSON.stringify(authInfo));
    dispatch(setUserMetadata(authInfo));
  }, [authInfo, initialize]);

  return (
    <IonApp>
      {authInfo?.loggedIn ? (
        <IonReactRouter>
          <IonSplitPane contentId="main" id="ionSplitPane">
            <Menu />
            <IonRouterOutlet id="main">
              <Switch>
                <Route path="/page/Dashboard" exact={true}>
                  <Dashboard />
                </Route>
                <Route path="/page/Devices" exact={true}>
                  <Devices />
                </Route>
                <Route path="/page/Devices/DeviceDetails" exact={true}>
                  <DeviceDetails />
                </Route>
                <Route path="/page/Datasheets" exact={true}>
                  <Datasheets />
                </Route>
                <Route path="/page/Settings" exact={true}>
                  <Settings />
                </Route>
                <Route path="/page/Tracking" exact={true}>
                  <Tracking />
                </Route>
                <Route path="/page/UserMgmt" exact={true}>
                  <UserMgmt />
                </Route>
                <Route path="/page/Alerts" exact={true}>
                  <Alerts />
                </Route>
                <Route path="/page/Graphs" exact={true}>
                  <Graphs />
                </Route>
              </Switch>
            </IonRouterOutlet>
          </IonSplitPane>
        </IonReactRouter>
      ) : (
        <IonReactRouter>
          <IonRouterOutlet>
            <Route path="/">
              <Login />
            </Route>
            <Route path="/page/Login" exact={true}>
              <Login />
            </Route>
            <Route path="/page/SignUp" exact={true}>
              <SignUp />
            </Route>
          </IonRouterOutlet>
        </IonReactRouter>
      )}
    </IonApp>
  );
};

export default App;
